export default __webpack_public_path__ + "static/flirting-1de4eb5192a57e6e8bb68dbdc5c633c7.svg";